import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=b1a52342&scoped=true&"
import script from "./RatingModal.vue?vue&type=script&lang=js&"
export * from "./RatingModal.vue?vue&type=script&lang=js&"
import style0 from "./RatingModal.vue?vue&type=style&index=0&id=b1a52342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a52342",
  null
  
)

component.options.__file = "RatingModal.vue"
export default component.exports